export const serviceCode = {
  GEN: "GEN",
  DGR: "DGR",
  CAO: "CAO",
  FRI: "FRI",
  PER: "PER",
  PRI: "PRI",
  VAL: "VAL",
  HUM: "HUM",
  EXP: "EXP",
  PIL: "PIL",
  ICE: "ICE",
  ELI: "ELI",
  ELM: "ELM",
  REQ: "REQ",
  AVI: "AVI",
  CUR: "CUR",
  AOG: "AOG",
  BIG: "BIG",
};
